import tinycolor from 'tinycolor2'
export const darkenHexColor = (hex) => {
    if (!hex) return "#000000";
    let r = parseInt(hex.substring(1, 3), 16);
    let g = parseInt(hex.substring(3, 5), 16);
    let b = parseInt(hex.substring(5, 7), 16);

    r = Math.max(0, r - 20);
    g = Math.max(0, g - 20);
    b = Math.max(0, b - 20);

    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

export const lightenHexColor = (hex) => {
    if (!hex) return "#FFFFFF";
    let r = parseInt(hex.substring(1, 3), 16);
    let g = parseInt(hex.substring(3, 5), 16);
    let b = parseInt(hex.substring(5, 7), 16);
    r = Math.min(255, r + 20);
    g = Math.min(255, g + 20);
    b = Math.min(255, b + 20);
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

export const getContrastColor = (hex) => {
    if (!hex) return '#000000';
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    // fórmula de luminosidad percibida
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 170 ? '#000000' : '#ffffff';
}


export const normalize = (c) => {
  let tc
  if (c?.hsv)      tc = tinycolor({ h: c.hsv.h, s: c.hsv.s, v: c.hsv.v, a: c.hsv.a })
  else if (c?.hsl) tc = tinycolor({ h: c.hsl.h, s: c.hsl.s, l: c.hsl.l, a: c.hsl.a })
  else if (c?.hex) tc = tinycolor(c.hex)
  else             tc = tinycolor(c || '#4F46E5')

  return {
    hex : tc.toHexString(),
    rgba: tc.toRgb(),
    hsv : tc.toHsv(),
    hsl : tc.toHsl(),
    a   : tc.getAlpha()
  }
}

export const deepMergeColor = (base, patch) => {
  const out = { ...base }
  if (patch.hsv) out.hsv = { ...base.hsv, ...patch.hsv }
  if (patch.hsl) out.hsl = { ...base.hsl, ...patch.hsl }
  if (patch.rgba) out.rgba = { ...base.rgba, ...patch.rgba }
  if (patch.hex) out.hex = patch.hex
  if (typeof patch.a === 'number') out.a = patch.a
  return out
}


export const setCssColors = (color, fontColor = null, tema = 1) => {
  const root = document.documentElement;
  root.style.setProperty("--color", color);
  root.style.setProperty("--color-layout", color);
  let darkColor =  darkenHexColor(color);
  let lightColor =  lightenHexColor(color);

  let coloresTema ={
    1: darkColor,
    2: lightColor,
  }
  
  let  hoverColor =  coloresTema[tema] || darkColor;

  root.style.setProperty("--color-hover", hoverColor);
  root.style.setProperty("--color-layout-hover", hoverColor);
  root.style.setProperty("--color-layout-contrast", getContrastColor(color));
  if(fontColor){
    root.style.setProperty("--color-layout-font", fontColor);
  }
}
